import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-erro-customizado',
    templateUrl: './alert-erro-customizado.component.html',
    styleUrls: ['./alert-erro-customizado.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertErroCustomizadoComponent {

  @Input() alertErro: boolean = false;
  @Input() alertErroTitulo: string;
  @Input() alertErroMensagem: string;
  @Input() alertErroBotao: string;
  @Output() alertErroFechou = new EventEmitter();

  constructor() { }

  fecharAlertErro() {
    this.alertErroFechou.emit('Fechou');
  }

}
